import { toastr } from 'react-redux-toastr';
import * as http from './http';
import ApiService from './service';

const serviceEndpoint = 'user/v1';

export default class PaymentService extends ApiService {
  public async verifyPayment(
    referenceCode: string,
    retryPayment: boolean,
    referralAmount?: number
  ) {
    const url = `${this.apiDomain}/${serviceEndpoint}/student/verify-payment`;
    const referralAmountData = referralAmount || 0;
    return http.post(
      url,
      {
        paymentReference: referenceCode,
        retryPayment,
        referralAmount: referralAmountData,
      },
      this.token
    );
  }
  public async getAdditionalFees() {
    const url = `${this.apiDomain}/${serviceEndpoint}/additional-fees`;
    return http.get(url, this.token);
  }
  public async getAdditionalFeeDetails(type: string, userId: string) {
    const url = `${this.apiDomain}/${serviceEndpoint}/additional-fees/${userId}/${type}`;
    return http.get(url, this.token);
  }
  public async initiatePayment(data: any) {
    let url = `${this.apiDomain}/${serviceEndpoint}/additional-fees`;
    if (
      data?.feeDetails?.isAbsenteeismFee ||
      data?.feeDetails?.isCancellationFee
    ) {
      url = `${this.apiDomain}/${serviceEndpoint}/additional-fees/initiate-absenteeism-payment`;
    }
    return http.post(url, data, this.token);
  }
  public async collectAdditionalFees(data: any, userId: string) {
    const url = `${this.apiDomain}/${serviceEndpoint}/additional-fees/${userId}`;
    return http.post(url, data, this.token);
  }

  public async verifyAdditionalFees(data: any, userId: string) {
    let url = `${this.apiDomain}/${serviceEndpoint}/additional-fees/${userId}/verify-payment`;
    if (data?.isAbsenteeismFee || data?.isCancellationFee) {
      url = `${this.apiDomain}/${serviceEndpoint}/additional-fees/absenteeism-addons/${userId}/verify-payment`;
    }
    return http.post(url, data, this.token);
  }

  public async getAdditionalAddonDetails() {
    const url = `${this.apiDomain}/${serviceEndpoint}/additional-fees/addon`;
    return http.get(url, this.token);
  }
  public async verifyPaymentLink(data: any) {
    const url = `${this.apiDomain}/payment/v1/web-hook/get-payment-link`;
    return http.post(url, data);
  }
  public async verifyPaymentLinkApi(data: any) {
    const options = {
      headers: {
        'Content-Type': 'application/json',
      },
    };
    try {
      const paymentLogObj = {
        paymentLink: data.paymentLink ?? '',
      };

      if (
        data.payType === 'additional-payment' ||
        data.payType === 'addon-payment'
      ) {
        return await http.post(
          `${this.apiDomain}/user/v1/additional-fees/check-payby-link/${data.userId}`,
          { paymentLogObj }
        );
      } else if (
        data.payType === 'quick-registration' ||
        data.payType === 'complete-payment'
      ) {
        return await http.post(
          `${this.apiDomain}/user/v2/check-payment-link-quick/${data.userId}`,
          { paymentLogObj }
        );
      } else if (
        data.payType === 'stage-payment' ||
        data.payType === 'registration' ||
        data.payType === 'transfer'
      ) {
        return await http.post(
          `${this.apiDomain}/user/v2/check-payment-link/${data.userId}`,
          { paymentLogObj }
        );
      } else if (data.payType === 'course-upgrade') {
        return await http.post(
          `${this.apiDomain}/user/v1/student/check-course-type-link-and-complete/${data.userId}`,
          { paymentLogObj }
        );
      } else if (
        data.payType === 'gear-change' ||
        data.payType === 'course-rule-change'
      ) {
        return await http.post(
          `${this.apiDomain}/user/v1/student/check-course-rule-change-link-and-complete/${data.userId}`,
          { paymentLogObj }
        );
      }
    } catch (err) {
      toastr.error('Error', 'Error in payment link:');
    }
  }
}
